import React, { useState, useMemo} from "react";
import styled from 'styled-components'
import PayablesTable from "./PayablesTable";

const HostAuditTable = (props) => {

  const [show, setShow] = useState(false);
  const [valueSelected, setValueSelected] = useState({})
  const [modalType, setModalType] = useState()

  // special processing... set audit_fee to extract_fee if the payment extract has been performed
  // or the audit_date is null
  // Otherwise set audit_fee equal to host's current rate per host_information

  for (let i = 0; i < props.data.length; i++)  {
      if (props.data[i].audit_fee === null || props.data[i].audit_date === null) {
        if (props.data[i].extract_fee !== null) {
            props.data[i].audit_fee = props.data[i].extract_fee
        }
        else {
          props.data[i].audit_fee = props.data[i].host_fee
        }
      }
      props.data[i]['sum_field'] = Number(props.data[i].audit_fee)
  }

    // table styles.  Taken from an example.  Investigate porting to css.  Produces warnings.

    const Wrapper = styled.section`
        padding: 0em;
        margin-top: -1.5rem;
        padding-top: 0rem;
        padding-bottom: 0rem;
        background: white;
        text-align: left;
        align-items: center;
        alignItems: center;
    `;
    const Styles = styled.div`
        padding: 1rem;

        .table {
          display: inline-block;
          border-spacing: 0;
          border: 1px solid #ccc;;

          .tr {
            :last-child {
              .td {
                ${'' /* border-bottom: 0; */}
                border-bottom: 1px solid #ccc;
              }
            }
          }

          .th {
            margin: 0;
            padding: .5rem;
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            color:  #00447c;
            font-weight: 600;

            :last-child {
              border-right: 1px solid #ccc;
            }
          }


          .td {
            margin: 0;
            padding: .5rem;
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            white-space: nowrap;
            text-overflow:ellipsis;
            overflow: hidden;

            :last-child {
              border-right: 1px solid #ccc;
            }
          }
        }
      `

  // apply blank spaces for search to null extract_date values

  function defaultToBlankSpaces (value) {
    return (value === null) ? "N" : value;
  }

  // simple array to map columns for table.


  const columns = useMemo(
    () => [
      {
        Header: () => (
            <span style={{display: "none"}} ></span>
        ),
        id: 'someId',
        columns: [

          //hidden columns
          {
            Header: "",
            id: "actual_start_date",
            accessor: "actual_start_date",
            filter: "dateFilter",
          },
          {
            Header: "",
            id: "sum_field",
            accessor: "sum_field",
          },

          {
            Header: "Game Date",
            accessor: "game_date",
            Cell: ({row}) => {
                // console.log(dataValue.game_date)
                const dataValue = row.original
                const showDetailInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("game contact")
                    setShow(true)
                }
            return (
                <div onClick={()=> showDetailInformation()} > {dataValue.game_date} </div>
            )
            }
          },
          {
            Header: "Game Name",
            accessor: "game_name",
            Cell: ({row}) => {
                const dataValue = row.original
                const showDetailInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("game contact")
                    setShow(true)
                }
            return (
                <div onClick={()=> showDetailInformation()} > {dataValue.game_name} </div>
            )
            }
          },
          {
            Header: "Community",
            accessor: "community_name",
            width: 362,
            Cell: ({row}) => {
                const dataValue = row.original
                const showDetailInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("game contact")
                    setShow(true)
                }
            return (
                <div onClick={()=> showDetailInformation()} > {dataValue.community_name} </div>
            )
            }
          },
          {
            Header: "Host",
            accessor: "host_name",
            width: 235,
            Cell: ({row}) => {
                const dataValue = row.original
                const showHostInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("host contact")
                    setShow(true)
                }
            return (
                <div onClick={()=> showHostInformation()} > {dataValue.host_name} </div>
            )
            }
          },
          {
            Header: "Fee",
            accessor: "audit_fee",
            width: 120,
            Cell: ({row}) => {
                const dataValue = row.original
                const showHostInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("host contact")
                    setShow(true)
                }
            return (
                <div style={{ textAlign: "right" }} onClick={()=> showHostInformation()} > {dataValue.audit_fee} </div>
            )
            }
          },
          {
            Header: "Reviewed",
            accessor: "audit_date",
            Cell: ({row}) => {
                const dataValue = row.original
                const showDetailInformation = () => {
                    setValueSelected(dataValue.game_schedule_id)
                    setModalType("game contact")
                    setShow(true)
                }
            return (
                <div onClick={()=> showDetailInformation()} > {defaultToBlankSpaces(dataValue.audit_date)} </div>
            )
            }
          },
        ]
      },
    ],
    []
  );
  return (
      <Wrapper>
        <Styles>
            <PayablesTable
              columns={columns}
              data={props.data}
              caller={props.caller}
              setRefresh={props.setRefresh}
              refresh={props.refresh}
              setShow={setShow}
              show={show}
              valueSelected={valueSelected}
              modalType={modalType}
               />
        </Styles>
    </Wrapper>
  );
}

export default HostAuditTable;